import api from 'src/api';

export const loginUser = (data) => {
  return api('/login', data, 'post');
};

export const getProfile = () => {
  return api('/profile', null, 'get');
};

export const sendOtp = (data) => {
  return api(`/send-otp`, data, 'post')
}

export const loginWithOtp = (data) => {
  return api(`/login-with-otp`, data, 'post')
}

export const sendOtpToContact = (data) => {
  return api(`/verify-token`, data, 'post')
}

export const disconnectCalendarById = (doctorId) => {
  return api(`/api/google-disconnect/${doctorId}`, null, 'delete');
}

export const logDevice = (data) => {
  console.log('[DeviceLog] Sending to backend via API:', data);
  return api('/device-log', data, 'post');
};

